'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.postProductIfNeeded = exports.postProductFailuer = exports.postProductSuccess = exports.postProductRequest = exports.POST_PRODUCT_FAILURE = exports.POST_PRODUCT_SUCCESS = exports.POST_PRODUCT_REQUEST = exports.fetchProductsIfNeeded = exports.failureProducts = exports.receiveProducts = exports.requestProducts = exports.invalidateProducts = exports.filterProducts = exports.INVALIDATE_PRODUCTS = exports.FILTER_PRODUCTS = exports.FAILURE_PRODUCTS = exports.RECEIVE_PRODUCTS = exports.REQUEST_PRODUCTS = undefined;

var _css = require('antd/lib/notification/style/css');

var _notification = require('antd/lib/notification');

var _notification2 = _interopRequireDefault(_notification);

var _css2 = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 商品相关Actions
                                                                                                                                                                                                                                                                   */


var _api = require('../api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_PRODUCTS = exports.REQUEST_PRODUCTS = 'REQUEST_PRODUCTS';
var RECEIVE_PRODUCTS = exports.RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';
var FAILURE_PRODUCTS = exports.FAILURE_PRODUCTS = 'FAILURE_PRODUCTS';
var FILTER_PRODUCTS = exports.FILTER_PRODUCTS = 'FILTER_PRODUCTS';
var INVALIDATE_PRODUCTS = exports.INVALIDATE_PRODUCTS = 'INVALIDATE_PRODUCTS';

var filterProducts = exports.filterProducts = function filterProducts(filter) {
    return {
        type: FILTER_PRODUCTS,
        filter: filter
    };
};

var invalidateProducts = exports.invalidateProducts = function invalidateProducts(filter) {
    return {
        type: INVALIDATE_PRODUCTS,
        filter: filter
    };
};

var requestProducts = exports.requestProducts = function requestProducts(filter) {
    return {
        type: REQUEST_PRODUCTS,
        filter: filter
    };
};

var receiveProducts = exports.receiveProducts = function receiveProducts(filter, json) {
    var data = json.data.map(function (x) {
        return _extends({
            id: x.product_id,
            thumb: x.default_image.url,
            title: x.title,
            subTitle: x.sub_title,
            type: {
                id: x.product_type.product_type_id,
                name: x.product_type.name
            },
            tags: x.tags,
            sort: x.default_order,
            status: x.status,
            created_at: x.created_at,
            preview: x.preview_images.map(function (x) {
                return { id: x.upload_id, url: x.url };
            }),
            desc: x.description_images.map(function (x) {
                return { id: x.upload_id, url: x.url };
            }),
            sku: x.skus,
            defaultImage: x.default_image ? { id: x.default_image.upload_id, url: x.default_image.url } : undefined
        }, x);
    });
    return {
        type: RECEIVE_PRODUCTS,
        filter: filter,
        products: data,
        received_at: Date.now(),
        pagination: json.meta.pagination
    };
};
var failureProducts = exports.failureProducts = function failureProducts(error) {
    return {
        type: FAILURE_PRODUCTS,
        error: error
    };
};

var shouldFetchProducts = function shouldFetchProducts(state, filter) {
    var products = state.product.products;
    if (products.items.length === 0) {
        return true;
    }
    if (products.isFetching) {
        return false;
    }
    // return products.didInvalidate
    return true;
};

var fetchProductsIfNeeded = exports.fetchProductsIfNeeded = function fetchProductsIfNeeded(filter, page) {
    return function (dispatch, getState) {
        if (shouldFetchProducts(getState(), filter)) {
            return dispatch(function (dispatch) {
                dispatch(requestProducts(filter));
                return (0, _api.fetchProducts)(filter, page).then(function (response) {
                    if (!response.ok) {
                        return Promise.reject(response);
                    }
                    return response.json();
                }).then(function (json) {
                    return dispatch(receiveProducts(filter, json));
                }).catch(function (error) {

                    dispatch(failureProducts(error));
                });
            });
        }
    };
};

var POST_PRODUCT_REQUEST = exports.POST_PRODUCT_REQUEST = 'POST_PRODUCT_REQUEST';
var POST_PRODUCT_SUCCESS = exports.POST_PRODUCT_SUCCESS = 'POST_PRODUCT_SUCCESS';
var POST_PRODUCT_FAILURE = exports.POST_PRODUCT_FAILURE = 'POST_PRODUCT_FAILURE';

var postProductRequest = exports.postProductRequest = function postProductRequest() {
    return {
        type: POST_PRODUCT_REQUEST
    };
};

var postProductSuccess = exports.postProductSuccess = function postProductSuccess(response) {
    return {
        type: POST_PRODUCT_SUCCESS,
        received_at: Date.now()
    };
};
var postProductFailuer = exports.postProductFailuer = function postProductFailuer(error) {
    return {
        type: POST_PRODUCT_FAILURE,
        error: error
    };
};

var shouldPostProduct = function shouldPostProduct(state) {
    var products = state.product.products;
    if (products.isPosting) {
        return false;
    }
    return true;
};

var postProductIfNeeded = exports.postProductIfNeeded = function postProductIfNeeded(values, router) {
    return function (dispatch, getState) {
        if (shouldPostProduct(getState())) {
            return dispatch(function (dispatch) {
                dispatch(postProductRequest());
                return (0, _api.postProduct)(values).then(function (response) {
                    _message2.default.success('提交成功');
                    router.push('/products'); // 二话不说 直接跳转
                    dispatch(fetchProductsIfNeeded());
                    return dispatch(postProductSuccess(response.data));
                }).catch(function (error) {
                    _notification2.default['error']({
                        message: '提交失败',
                        description: error.response && error.response.data && error.response.data.message
                    });
                    console.error(error);
                    return dispatch(postProductFailuer(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/product.js
// module id = 876
// module chunks = 0